module.exports = __webpack_public_path__ + "static/img/rong1.68b0225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rong1.jpg
// module id = uQ8y
// module chunks = 52